import { render, staticRenderFns } from "./Robot_ai_vip_detail.vue?vue&type=template&id=3f8184e2&scoped=true&"
import script from "./Robot_ai_vip_detail.vue?vue&type=script&lang=js&"
export * from "./Robot_ai_vip_detail.vue?vue&type=script&lang=js&"
import style0 from "./Robot_ai_vip_detail.vue?vue&type=style&index=0&id=3f8184e2&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "3f8184e2",
  null
  
)

export default component.exports